import { render, staticRenderFns } from "./ConclusionComponent.vue?vue&type=template&id=64cd961e&scoped=true&"
import script from "./ConclusionComponent.vue?vue&type=script&lang=js&"
export * from "./ConclusionComponent.vue?vue&type=script&lang=js&"
import style0 from "./ConclusionComponent.vue?vue&type=style&index=0&id=64cd961e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cd961e",
  null
  
)

export default component.exports